import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useUser } from "../users/providers/UserProvider";
import ROUTES from "./routesModel";

/**
 * Wraps a route and redirects to login if the user is not authenticated.
 * Saves the current location so login can redirect back after success.
 */
const RequireAuth = ({ children }) => {
  const { user, authReady } = useUser();
  const location = useLocation();

  // Auth state hasn't hydrated yet (Supabase session bridge in flight).
  // Render nothing rather than treating "unknown" as "signed out" and
  // bouncing to /login.
  if (!authReady) return null;

  if (!user) {
    return (
      <Navigate
        to={ROUTES.LOGIN}
        state={{ from: location }}
        replace
      />
    );
  }

  return children;
};

export default RequireAuth;
